import React, { useState, useEffect } from 'react';
import {
  Divider,
  Card,
  CardHeader,
  Container,
  Grid,
  Box,
  Tab,
} from '@mui/material';
import axios from 'axios';
import { url } from 'src/Helpers/utils/Constant';
import { IRequestOwnerInfo } from 'src/Types/module/UpdateRequest/RequestCompanyInfo';

import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import OwnerInfoIndex from './OwnerInfoIndex';

const RequestOwnerInfo = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [ownerInfo, setOwnerInfo] = useState<IRequestOwnerInfo[]>([]);
  const [value, setValue] = React.useState('pending');
  useEffect(() => {
    setIsLoading(true);
    try {
      (async function () {
        const { data } = await axios.get(
          `${url}/api/atab/member-company/update-request/member/owner?status=${value}`
        );

        if (data.success) {
          setOwnerInfo(data.data);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })();
    } catch (error) {
      setIsLoading(false);
    }
  }, [value]);

  return (
    <Container sx={{ mt: 4 }} maxWidth='xl'>
      <Grid
        container
        direction='row'
        justifyContent='center'
        alignItems='stretch'
        spacing={3}
      >
        <Grid item xs={12}>
          <TabContext value={value}>
            <Card>
              <CardHeader
                title='Company Owner information'
                action={
                  <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderColor: 'divider' }}>
                      <TabList
                        onChange={(_event, newValue) => setValue(newValue)}
                        aria-label='lab API tabs example'
                      >
                        <Tab label='Pending' value='pending' />
                        <Tab label='Approved' value='approved' />
                        <Tab label='Rejected' value='rejected' />
                      </TabList>
                    </Box>
                  </Box>
                }
              />
              <Divider />
              <TabPanel value='pending'>
                <OwnerInfoIndex isLoading={isLoading} ownerInfo={ownerInfo} />
              </TabPanel>
              <TabPanel value='approved'>
                <OwnerInfoIndex isLoading={isLoading} ownerInfo={ownerInfo} />
              </TabPanel>
              <TabPanel value='rejected'>
                <OwnerInfoIndex isLoading={isLoading} ownerInfo={ownerInfo} />
              </TabPanel>
            </Card>
          </TabContext>
        </Grid>
      </Grid>
    </Container>
  );
};

export default RequestOwnerInfo;
